const React = require('react')

import {
  Carousel,
  Col,
  Image,
  Modal,
  Row,
} from 'react-bootstrap'

export default class SiteModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: true,
      subjects: [],
      years: [],
      contentStandards: [],
      learningSkills: [],
      keywords: [],
      curriculumVersions: [],
      syllabuses: [],
      units: [],
    }
  }

  componentDidMount() {
    this.setState({
      years: this.props.tags.filter(tag => tag.type == 'year'),
      subjects: this.props.tags.filter(tag => tag.type == 'subject'),
      learningSkills: this.props.tags.filter(tag => tag.type == 'learning_skill'),
      contentStandards: this.props.tags.filter(tag => tag.type == 'content_standard'),
      keywords: this.props.tags.filter(tag => tag.type == 'keyword'),
      curriculumVersions: this.props.tags.filter(tag => tag.type == 'curriculum_version'),
      syllabuses: this.props.tags.filter(tag => tag.type == 'syllabus'),
      units: this.props.tags.filter(tag => tag.type == 'unit'),
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({
        showModal: true
      })
    }
  }

  render() {
    const years = this.props.tags.filter(tag => tag.type == 'year')
    const contentStandards = this.props.tags.filter(tag => tag.type == 'content_standard')
    const subjects = this.props.tags.filter(tag => tag.type == 'subject')
    const learningSkills = this.props.tags.filter(tag => tag.type == 'learning_skill')
    const keywords = this.props.tags.filter(tag => tag.type == 'keyword').sort().reverse()
    const curriculumVersions = this.props.tags.filter(tag => tag.type == 'curriculum_version')
    const syllabuses = this.props.tags.filter(tag => tag.type == 'syllabus')
    const units = this.props.tags.filter(tag => tag.type == 'unit')

    return (
      <Modal show={this.state.showModal} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>
            Preview of {this.props.site.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={8} sm={8}>
              {this.props.source != 'lessonplanner' &&
                <Carousel
                  interval={null}
                  indicators={false}
                >
                  {this.props.thumbnails.map((thumbnail, index) => (
                    <Carousel.Item key={index}>
                      <Image
                        width={800}
                        height={600}
                        src={thumbnail.url}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              }
              {this.props.source == 'lessonplanner' &&
                <Image
                  width="100%"
                  src={this.props.thumbnails[0].url}
                />
              }
              <br />
              <a onClick={() => {window.open(this.props.site.external_url, '_blank').focus()}} hidden={this.props.site.external_url == null}>View this Site</a>
            </Col>
            <Col md={4} sm={4}>
              {this.props.site.author_name && this.props.source != 'lessonplanner' &&
                <div>
                  <h5>Published by</h5>
                  <p className="text-muted">
                    {this.props.site.author_name} ({this.props.site.school_name})
                  </p>
                </div>
              }
              {this.props.source != 'lessonplanner' &&
                <div>
                  <h5>Published on</h5>
                  <p className="text-muted">
                    {this.props.site.source_created_at}
                  </p>
                </div>
              }
              <div>
                <h5>Description</h5>
                {!this.props.site.description && (
                  <p className="text-muted">
                    No description provided
                  </p>
                )}
                {this.props.site.description && this.props.site.description.split("\n").map((line, i) => (
                  <p className="text-muted" key={i}>{line}</p>
                ))}
              </div>
              {years.length > 0 && (
                <div>
                  <h5>Year</h5>
                  <p className="text-muted">{years.map(tag => tag.value).join(', ')}</p>
                </div>
              )}
              {subjects.length > 0 && (
                <div>
                  <h5>Subject</h5>
                  <p className="text-muted">{subjects.map(tag => tag.value).join(', ')}</p>
                </div>
              )}
              {curriculumVersions.length > 0 && (
                <div>
                  <h5>Curriculum Version</h5>
                  <p className="text-muted">{curriculumVersions.map(tag => tag.value).join(', ')}</p>
                </div>
              )}
              {learningSkills.length > 0 && (
                <div>
                  <h5>Skill/Topic</h5>
                  <p className="text-muted">{learningSkills.map(tag => tag.value).join(', ')}</p>
                </div>
              )}
              {contentStandards.length > 0 && (
                <div>
                  <h5>Content Standard</h5>
                  <p className="text-muted">{contentStandards.map(tag => tag.value).join(', ')}</p>
                </div>
              )}
              {syllabuses.length > 0 && (
                <div>
                  <h5>Theme</h5>
                  <p className="text-muted">{syllabuses.map(tag => tag.value).join(', ')}</p>
                </div>
              )}
              {units.length > 0 && (
                <div>
                  <h5>Unit</h5>
                  <p className="text-muted">{units.map(tag => tag.value).join(', ')}</p>
                </div>
              )}
              {keywords.length > 0 && (
                <div>
                  <h5>Keywords</h5>
                  <p className="text-muted">{keywords.map(tag => tag.value).join(', ')}</p>
                </div>
              )}
              <br />
              {this.props.children}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}